import React from "react";
import AuthPageTemplate from "./AuthPageTemplate";

const empresasTheme = {
  background: "bg-[#2f1c92]",
  panelBg: "bg-white",
  inputBg: "bg-[#dcd4ff]",
  accentText: "text-[#5d00c5]",
  mutedText: "text-[#563f8f]",
  buttonPrimary: "bg-[#7c4dff] hover:bg-[#5f3ad9]",
  buttonText: "text-white",
  toggleActiveBg: "bg-[#7c4dff]",
  toggleInactiveBg: "bg-transparent",
  toggleActiveText: "text-white",
  toggleInactiveText: "text-[#5d00c5]",
  link: "text-[#5d00c5] hover:underline",
  mfaBannerBg: "bg-[#5d00c5]",
};

const EmpresasAuthPage = () => (
  <AuthPageTemplate
    variant="empresas"
    theme={empresasTheme}
    title="Bienvenido a Mou Empresas"
    redirectPath="/empresas"
  />
);

export default EmpresasAuthPage;
